import { render, staticRenderFns } from "./PortalLayout.vue?vue&type=template&id=1f9bb530&"
import script from "./PortalLayout.vue?vue&type=script&lang=js&"
export * from "./PortalLayout.vue?vue&type=script&lang=js&"
import style0 from "./PortalLayout.vue?vue&type=style&index=0&id=1f9bb530&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports